import React from 'react';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Grid from '@material-ui/core/Grid';
import $ from "jquery";
import { Button, Dropdown } from 'semantic-ui-react';

import ReadCookie from '../../../functions/readcookies';
import RideSideScreen from './rightSideScreen';
import Server from '../../../functions/server';
import AppServer from '../../../functions/servername';
import MobileView from './mobileview';
import Title from '../../title';
import './dualscreen.css';
import Loading from '../../loading';
import Permission from '../../../functions/permission';

class DualScreenPlaceOrder extends React.Component {

  state = {
    menu: 'Invoice', model: [], cetegory: [], assembly: [], group: [], menuPermission: [], combo: []
  }

  componentDidMount() {
    this.getCustomer();
    this.getSpares();
    this.getPermission();
  }

  getPermission() {
    let menuPermission = Permission('customer-order', this.props.menus);
    this.setState({ menuPermission })
  }

  getCustomer() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let executiveId = cook.id;
    $.ajax({
      type: 'POST', data: { 'userId': executiveId },
      url: Server() + 'customer/getallcustomers.php',
      success: function(data) {
        var customer = [];
        let customers = [];
        try {
          customers = JSON.parse(data);
          JSON.parse(data).map((y) => {
            let text = y.id+"->"+y.name+"->"+y.machine_no+"->"+y.taluk+"->"+y.mobile+"->"+y.alt_mobile+'->'+y.emp_id;
            customer.push({key: text, text: text, value: text});
          });
        } catch (e) {
        }
        context.setState({ customerOption: customer, customers })
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  getSpares() {
    let context = this;
    context.setState({ load: true, message: 'Getting Spares!!!' })
    $.ajax({
      type: 'POST',
      url: AppServer() + 'ui/gethomeitems.php',
      success: function(data) {
        let group = [];
        let assembly = [];
        let cetegory = [];
        let model = [];
        try {
          data = JSON.parse(data);
          data.map((c) => {
            if (c.type == 'Model') { model.push(c); }
            if (c.type == 'Category') { cetegory.push(c); }
            if (c.type == 'Set') { assembly.push(c); }
            if (c.type == 'Section') { group.push(c); }
          })
          context.setState({ partCodeOption: data, model, cetegory, assembly, group, load: false })
        } catch (error) {
          alert('Error!!!');
          context.setState({ load: false })
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!!')
      }
    });
  }


  getSparesWithModel(model) {
    let context = this;
    context.setState({ load: true, message: 'Getting Spares!!!' })
    $.ajax({
      type: 'POST', data: { model },
      url: AppServer() + 'ui/gethomeitems.php',
      success: function(data) {
        let group = [];
        let assembly = [];
        let cetegory = [];
        let model = [];
        let combo = [];
        try {
          data = JSON.parse(data);
          data.map((c) => {
            if (c.type == 'Model') { model.push(c); }
            if (c.type == 'Category') { cetegory.push(c); }
            if (c.type == 'Set') { assembly.push(c); }
            if (c.type == 'Section') { group.push(c); }
            if (c.type == 'Combo') { combo.push(c); }
          })
          context.setState({ partCodeOption: data, model, cetegory, assembly, group, combo, load: false })
        } catch (error) {
          alert('Error!!!');
          context.setState({ load: false })
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!!')
      }
    });
  }
  
  

  refreshData() {
    this.child.getData1();
  }

  render() {
    let { customerId, load, message } = this.state;
    return (
      <div>
        <Title title={'Customer Order'} openDrawer={this.props.openDrawer} />
        { this.state.menuPermission.view ?
          (
            <div>
              <Loading load={load} message={message} />
              <Grid container spacing={2}>
                <Grid item xs={7}>
                  <div style={{backgroundColor: '#F3FFE0', width: '100%', height: '89vh'}}>
                    <MobileView combo={this.state.combo} getSparesWithModel={this.getSparesWithModel.bind(this)} refreshData={this.refreshData.bind(this)} model={this.state.model} cetegory={this.state.cetegory} assembly={this.state.assembly} group={this.state.group} />
                  </div>
                </Grid>
                <Grid item xs={5}>
                  <RideSideScreen menuPermission={this.state.menuPermission} ref={instance => { this.child = instance; }} />
                </Grid>
              </Grid>
            </div>
          ):(<center>You Are Not Allow To Access This Menu!!!!</center>)
        }
      </div>
    );
  }
}

export default DualScreenPlaceOrder;
